module.exports = __webpack_public_path__ + "static/media/lambdaschool.0c40f533.jpg";